import React, { useEffect, useRef, useState } from 'react';


const HomepageComp2 = () => {

  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(entry.target);
      }
    });
  });

  useEffect(() => {
    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [ref]);

  return (
    <div className={`homepage-component-container homepage-comp2-container relative ${isVisible ? 'fade-in' : ''}`} ref={ref}>

      <div class="absolute right-[15%] top-12 z-0 hidden h-60 w-[60%] rounded-3xl bg-[#FCECC9] lg:block"></div>

      <div className='grid grid-cols-2 gap-12 relative z-2'>
        <div className='grid grid-cols-2'>
          <div className='homepage-img2 z-4 relative'></div>
          <div className='homepage-img3 z-2 relative'></div>
          <div class="absolute -bottom-24 left-28 z-3 hidden h-[300px] w-[300px] rounded-full border-[40px] border-[#DAA520] shadow-md lg:block"></div>
        </div>
        <div>
          <h1 className='homepage-title2'>Uncover the Future of Responsible Gold Mining with Merge Turk Gold</h1>
          <p className='homepage-text1'>Redefining the gold mining industry through our commitment to sustainability and advanced technology, we prioritize the preservation of natural landscapes while specializing in alluvion and rock mining.</p>
          <p class="inline-block rounded-full bg-gray-100 px-8 py-4 text-lg text-[#DAA520] lg:text-xl xl:text-2xl">
            <span class="mr-2 font-semibold xl:text-4xl">10+</span>
            <span>Years of Ethical Mining Practices</span>
          </p>
        </div>
      </div>

    </div>
  )
}

export default HomepageComp2